import clsx from "clsx";
import { percentByRange } from "@/core/helpers/percentOfRange";
import useAppSelector from "@/core/helpers/useAppSelector";
import { HeartPulseIcon, PizzaIcon, SmileIcon } from "@/shared/icons";
import { CircleIndicator } from "@/shared/ui";
import { playerInfoSelector } from "@/domains/player/slice";
import PlayerMenuCharacterDataCard from "@/domains/playerMenu/components/character/data/PlayerMenuCharacterDataCard";

export default function PlayerMenuCharacterStateCardContainer() {
  const playerInfo = useAppSelector(playerInfoSelector);

  const healthPercent = percentByRange(
    playerInfo?.character?.vitals.health.min || 0,
    playerInfo?.character?.vitals.health.max || 0,
    playerInfo?.character?.vitals.health.value || 0,
  );

  const satietyPercent = percentByRange(
    playerInfo?.character?.vitals.satiety.min || 0,
    playerInfo?.character?.vitals.satiety.max || 0,
    playerInfo?.character?.vitals.satiety.value || 0,
  );

  const happinessPercent = percentByRange(
    playerInfo?.character?.vitals.satiety.min || 0,
    playerInfo?.character?.vitals.satiety.max || 0,
    playerInfo?.character?.vitals.satiety.value || 0,
  );

  return (
    <PlayerMenuCharacterDataCard>
      <div className="flex flex-col w-full h-full">
        <div className="grid grid-cols-3 gap-2">
          <div className="flex flex-col gap-3.5 items-center">
            <div className="relative h-[3.25rem] aspect-square shrink-0">
              <CircleIndicator
                fillPercent={healthPercent}
                className="h-full w-full"
                accentColor="#84FF97"
                strokeWidth={1}
              />
              <HeartPulseIcon
                size={22}
                className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 text-[#84FF97] w-5"
              />
            </div>
            <div
              className={clsx(
                "h-[3.875rem] w-full flex flex-col items-center justify-center gap-0.5",
                "rounded-[0.5rem] bg-gradient-to-b from-[#84FF97]/10 to-transparent",
              )}
            >
              <div className="text-10 font-bold">ЗДОРОВЬЕ</div>
              <div className="text-14 font-bold text-[#84FF97]">{healthPercent}%</div>
            </div>
          </div>
          <div className="flex flex-col gap-3.5 items-center">
            <div className="relative h-[3.25rem] aspect-square shrink-0">
              <CircleIndicator
                fillPercent={happinessPercent}
                className="h-full w-full"
                accentColor="#B182FF"
                strokeWidth={1}
              />
              <SmileIcon
                size={22}
                className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 text-[#B182FF] w-5"
              />
            </div>
            <div
              className={clsx(
                "h-[3.875rem] w-full flex flex-col items-center justify-center gap-0.5",
                "rounded-[0.5rem] bg-gradient-to-b from-[#B182FF]/10 to-transparent",
              )}
            >
              <div className="text-10 font-bold">НАСТРОЕНИЕ</div>
              <div className="text-14 font-bold text-[#B182FF]">{happinessPercent}%</div>
            </div>
          </div>
          <div className="flex flex-col gap-3.5 items-center">
            <div className="relative h-[3.25rem] aspect-square shrink-0">
              <CircleIndicator
                fillPercent={satietyPercent}
                className="h-full w-full"
                accentColor="#FFB45C"
                strokeWidth={1}
              />
              <PizzaIcon
                size={22}
                className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 text-[#FFB45C] w-5"
              />
            </div>
            <div
              className={clsx(
                "h-[3.875rem] w-full flex flex-col items-center justify-center gap-0.5",
                "rounded-[0.5rem] bg-gradient-to-b from-[#FFB45C]/10 to-transparent",
              )}
            >
              <div className="text-10 font-bold">СЫТОСТЬ</div>
              <div className="text-14 font-bold text-[#FFB45C]">{satietyPercent}%</div>
            </div>
          </div>
        </div>
        <div className="mt-auto text-18 font-bold">Состояние персонажа</div>
      </div>
    </PlayerMenuCharacterDataCard>
  );
}
